import request from "../../utils/axios";

export const apiLogin = async (data) => {
  const res = await request.post({ url: "/member/auth/account-login", data });
  return res;
};

export const apiTokenLogin = async (data) => {
  const res = await request.post({ url: "/member/auth/token-login", data });
  return res;
};

export const apiLogout = async () => {
  const res = await request.post({ url: "/member/auth/logout" });
  return res;
};

export const apiTest = async () => {
  const res = await request.get({ url: "/member/auth/test" });
  return res;
};
